/**
 * 这个工具主要的是处理时间moment的方法
 */

import moment, { Moment } from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/date-picker/locale/zh_CN';

moment.locale('zh-cn');

const ForMatter = {
  date: 'YYYY-MM-DD',
  month: 'YYYY-MM',
  year: 'YYYY'
};

export { locale, moment, Moment, ForMatter };

/**
 * 格式化
 * @param value
 * @param format
 */
export function formatMoment(value: any, pattern?: string) {
  return moment(value).format(pattern || 'YYYY-MM-DD');
}

/**
 * 获取时间格式
 * @param value 传入的时间值
 * @param type 时间的类型，默认时候YYYY-MM-DD
 */
export function formatDate(value: any, type?: '-' | '.' | null, pattern?: string) {
  if (!value) {
    return '--';
  }
  if (type) {
    return moment(value).format(`YYYY${type}MM${type}DD`);
  }
  return moment(value).format(pattern ? pattern : 'YYYY-MM-DD');
}

/**
 * 获取时间格式
 * @param value 传入的时间值
 * @param type 时间的类型，默认时候YYYY-MM-DD
 */
export function formatMonth(value: any, pattern?: any) {
  if (!value) {
    return '--';
  }
  return formatMoment(value, pattern || 'YYYY-MM');
}

/**
 * 创建时间
 * @param value 传入的时间值
 * @param type 时间的类型，默认时候YYYY-MM-DD
 */
export function createDate(type?: '-' | '.' | null, pattern?: string) {
  if (type) {
    return moment().format(`YYYY${type}MM${type}DD`);
  }
  return moment().format(pattern ? pattern : 'YYYY-MM-DD HH:mm:ss');
}

/**
 * 时间的比较
 * @param start
 * @param end
 */
export function isSame(start: Moment | string, end?: Moment | string, format?: string) {
  start = moment(start).format(format || 'YYYY-MM-DD');
  end = moment(end || moment()).format(format || 'YYYY-MM-DD');
  return start === end;
}

/**
 * 获取当天日期
 * @returns {string} YYYY-MM-DD
 */
export function getCurrentDate() {
  return moment().format('YYYY-MM-DD');
}

/**
 * 获取当年
 * @returns {string} YYYY
 */
export function getCurrentYear() {
  return moment().format('YYYY');
}

/**
 * 获取年 当前年份N年前
 * @returns {string} YYYY-MM-DD
 */
export function getBeforeFormatDate(num: number, chooseDate?: string) {
  if (chooseDate) {
    return moment(chooseDate)
      .subtract(num, 'years')
      .format('YYYY');
  }
  return moment()
    .subtract(num, 'years')
    .format('YYYY');
}

/**
 * 获取年 当前年份N年前-1月时间戳
 * @returns
 */
export function getBeforeTime(num: number) {
  return new Date(
    moment()
      .subtract(num, 'years')
      .format('YYYY-01')
  ).getTime();
}

/**
 * 获取年 当前年份N年前-1月时间戳
 * @returns
 */
export function getBeforeSpecMonthTime(num: number, month: string) {
  return new Date(
    moment()
      .subtract(num, 'years')
      .format(`YYYY-${month}`)
  ).getTime();
}

/**
 * 获取 当前年份月份时间戳
 * @returns
 */
export function getNowDateMonthTime() {
  return new Date(moment().format('YYYY-MM')).getTime();
}

/**
 * 获取时间的秒数（参数：d，h,m,s） 12m
 * @param time 失效时间
 */
export function getSecond(str: any) {
  var str1 = str.substr(0, str.length - 1); // 时间数值
  var str2 = str.substr(str.length - 1, 1); // 时间单位
  if (str2 === 's') {
    return str1 * 1000;
  } else if (str2 === 'm') {
    return str1 * 60 * 1000;
  } else if (str2 === 'n') {
    return str1 * 60 * 60 * 1000;
  } else if (str2 === 'd') {
    return str1 * 24 * 60 * 60 * 1000;
  }
  return str;
}

/**
 * 获取倒计时的时间
 * @param startTime
 * @param endTime
 */
export function getLeaveTime(startTime: string = new Date().toString(), endTime: string = '2019-11-14 17:00:00') {
  if (startTime === '' || endTime === '') {
    return '';
  }
  const m1 = Number(moment(startTime).format('x'));
  const m2 = Number(moment(endTime).format('x'));
  if (m1 > m2) {
    return '0时0分0秒';
  }
  const length = moment.duration(m2 - m1);
  const months = length.months();
  const days = length.days();
  const hours = length.hours();
  const minutes = length.minutes();
  const seconds = length.seconds();
  if (months === 0) {
    return `${days}天${hours}时${minutes}分${seconds}秒`;
  }
  return `${months}月${days}天${hours}时${minutes}分${seconds}秒`;
}

/**
 * 获取倒计时的时间(秒数 + 1)
 * @param startTime
 */
export function getLeaveStartTime(startTime: string = new Date().toString()) {
  const leaveTime = moment(startTime)
    .add(1, 's')
    .format('YYYY-MM-DD HH:mm:ss');
  return leaveTime;
}

/**
 * 比较时间
 * @param time
 */
export function isBefore(time: string) {
  return moment().isBefore(moment(time));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/momentUtils.ts